import React, { useEffect, useState, useRef } from "react";
import { Form, Modal } from "react-bootstrap";
import Layout from "../../components/Layout";
import { callAPI } from "../../helper/apiUtils";
import LanguageContext from "../../helper/LanguageContext";
import { DE } from "../../Languages/DE";
import { EN } from "../../Languages/EN";
import { corporateForms } from "../../Languages/vars/Corporate";
import { Positions } from "../../Languages/vars/Positions";
import LocationSearchInput from "../../components/LocationSearchInput";
import SuggestionInput from "./SuggestionInput";
import { $crud } from "../../helper/CrudFactory";
import MapComponent from "../../components/MapComponent";
import { useHistory } from "react-router-dom";
import { BsChevronDown } from "react-icons/bs";
import CompanyCorporateDialog from "./Dialogs/CompanyCorporateDialog";
import CompanyPositionDialog from "./Dialogs/CompanyPositionDialog";
import { Roles } from "../../Languages/vars/Roles";
import CompanyRoles from "./Dialogs/CompanyRoles";
import { $user } from "../../helper/UserFactory";
import { getCompanyRoles, loadCustomBranches } from "../../helper/customBranches";
import { Animated } from "react-animated-css";
import { goBack, BASE_URL } from "../../helper/constants";
import { convertBranchRole, convertPosition } from "../../helper/convertor";
import { Discuss, Rings, Oval } from 'react-loader-spinner'
import { KJUUP_COLORS } from "../../helper/constants";
import DepartLocaDialogue from "./Dialogs/DepartLocaDialogue";
import { useSelector } from "react-redux";
import "./addcompany.css";

function AddCompany(props) {
  const [searchCity, setSearchCity] = useState('');
  const [mainVal, setMainVal] = useState('');

  const [suggestionOver, setSuggestionOver] = useState(false)
  const [isGettingSuggestion, setIsGettingSuggestions] = useState(false)
  const [visible, setVisible] = useState(true);
  const [params, setParams] = useState({
    // position: "",
    name: "",
    email: "",
    website: "",
    corporateForm: "",
    branch: "",
    street: "",
    postCode: "",
    city: "",
    country: "",
    lat: "",
    long: "",
    houseNo: "",
    full_address: "",
    deptLocation: "",
    deptLocationName: ""
  });
  const [paramsLoaded, setParamsLoaded] = useState({
    name: false,
    email: false,
    corporateForm: false,
    branch: false,
  });
  const user = $user.get();
  const [companyRoles, setCompanyRoles] = useState(Roles);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadCustomBranches().then(() => setCompanyRoles(getCompanyRoles()));
  }, []);
  const [loadingStage, setLoadingStage] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [errors, setErrors] = useState({
    // position: "",
    name: "",
    email: "",
    corporateForm: "",
    branch: "",
    street: "",
    postCode: "",
    city: "",
    country: "",
    lat: "",
    long: "",
    houseNo: "",
    full_address: "",
    deptLocation: '',
    deptLocationName: ""
  });
  const { isGerm, strings } = React.useContext(LanguageContext);
  const [show, setShow] = useState(false);
  const [showRoleDialog, setRoleDialog] = useState(false);
  const [showCorporateForm, setCorporateForm] = useState(false);
  const [showPositionDialog, setPositionDialog] = useState(false);
  const [roleSelected, setRoleSelected] = useState(false);
  const [selectName, setSelectName] = useState()
  const [companies, setCompanies] = useState([]);
  const [showSuggestion, setShowSuggestion] = useState(false);
  const [searchSuggestion, setSearchSuggestion] = useState('');
  const [companiesSuggestion, setCompaniesSuggestion] = useState([]);
  const [suggestionPage, setSuggestionPage] = useState(1)
  const [deptloc, setdeptloc] = useState([])
  const [showDepartModal, setShowDepartModal] = useState(null)
  const deptLocButtonRef = useRef(null)


  useEffect(() => {
    if (!searchSuggestion) {
      setShowSuggestion(false)
      setCompaniesSuggestion([])
    }
    else {
      console.log('sds')
      setShowSuggestion(true)
      _searchCompnies(searchSuggestion)
    }
  }, [searchSuggestion])

  const _searchCompnies = async (e) => {
    setIsGettingSuggestions(true)
    const { data } = await callAPI(`/company/getRegisterOrUnregisteredCompany?page=${1}&limit=200&query=${e}`, null, "GET");
    setIsGettingSuggestions(false)
    if (data.companies && data.companies?.length > 0) {
      setSuggestionPage(2)
      setCompaniesSuggestion(data.companies)
    }
    else {
      setShowSuggestion(false)
    }
  }

  const _onEndOfSuggestions = async () => {
    if (!suggestionOver && !isGettingSuggestion) {
      setIsGettingSuggestions(true)
      const { data } = await callAPI(`/company/getRegisterOrUnregisteredCompany?page=${suggestionPage}&limit=200&query=${searchSuggestion}`, null, "GET");
      if (data.companies && data.companies?.length > 0) {
        setSuggestionOver(false)
        setSuggestionPage(suggestionPage + 1)
        setCompaniesSuggestion([...companiesSuggestion, ...data.companies])
      }
      else {
        setSuggestionOver(true)
        // setCompaniesSuggestion([])
      }
      setIsGettingSuggestions(false)
    }
  }

  const setParam = (name, value) => {
    console.log(name, value)
    setParams((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
    setErrors((prev) => {
      return {
        ...prev,
        [name]: "",
      };
    });
  };
  const [suggestionLoaded, setSuggestionLoaded] = useState(false);
  const [ownerId, setOwnerId] = useState(null);
  const [suggestionName, setSuggestionName] = useState(null);
  const handleValidation = () => {
    let errors = {};
    let formIsValid = true;
    //Role
    // if (!params.position) {
    //   formIsValid = false;
    //   errors["position"] = strings.invalid_fiels;
    // }
    //Firstname
    if (!params.name) {
      formIsValid = false;
      errors["name"] = strings.invalid_fiels;
    }
    if (!params.email) {
      formIsValid = false;
      errors["email"] = strings.invalid_fiels;
    }

    if (!params.branch) {
      formIsValid = false;
      errors["branch"] = strings.invalid_fiels;
    }

    if (!params.full_address) {
      formIsValid = false;
      errors["full_address"] = strings.invalid_fiels;
    }

    if (!params.deptLocation && deptloc?.length > 0) {
      formIsValid = false;
      errors["deptLocation"] = strings.invalid_fiels;
    }

    setErrors(errors);
    return formIsValid;
  };
  const corporateForm = corporateForms;
  const [isInvalid, setIsInvalid] = useState(false);
  const [invalidMsg, setInvalidMsg] = useState("");
  const history = useHistory();
  const requestConfirmation = async () => {
    if (handleValidation()) {
      let filterData = { ...params };
      setLoading(true);
      setLoadingStage("sending");
      try {
        const { data } = await callAPI("/company", null, "POST", filterData);
        if (!data.status) {
          setLoadingStage(null);
          setLoading(false);
          setSuccessMessage(data.message);
          return;
        } else {
          setLoadingStage("completing");
          await $user.getProfile();
          setLoadingStage(null);
          setLoading(false);
          setSuccessMessage(data.message);
          return;
        }
      } catch (e) {
        console.log(e);
        setLoadingStage(null);
      }
      setLoading(false);
      setLoadingStage(null);
    } else {
      console.log(errors);
    }
  };
  const getList = async () => {
    try {
      const { data } = await callAPI(
        "/company/getRegisterOrUnregisteredCompany",
        {},
        "GET"
      );
      if (data.status) {
        setCompanies(data.companies);
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    // getList();
    if (props && props.location && props.location.state) {
      let suggestion = props.location.state
      let add = `${suggestion.houseNo ? suggestion.houseNo + ", " : ""}${suggestion.street ? suggestion.street + ", " : ''}${suggestion.city ? suggestion.city + ", " : ""}${suggestion.postCode ? suggestion.postCode + ", " : ""}${suggestion.country ? suggestion.country : ''}`
      setMainVal(suggestion.full_address ? suggestion.full_address : add)
      setParams((prev) => {
        return {
          ...prev,
          ...props.location.state,
          position: convertPosition(isGerm, props.location.state?.position),
          full_address: suggestion.full_address ? suggestion.full_address : add
        };
      });
      _getDepartmentAndLocations(suggestion.id)
    }
  }, []);

  const applyAddressSuggestion = (addr) => {
    setMainVal(addr.description);
    setParams((prev) => ({
      ...prev,
      full_address: addr.description,
      street: addr.street || "",
      houseNo: addr.houseNo || "",
      city: addr.city || "",
      postCode: addr.postCode || "",
      country: addr.country || "",
      lat: addr.lat || "",
      long: addr.long || "",
    }));
    setErrors((prev) => ({ ...prev, full_address: "" }));
  };

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  const getSuggestion = async (suggestion) => {
    let add = `${suggestion.houseNo ? suggestion.houseNo + ", " : ""}${suggestion.street ? suggestion.street + ", " : ''}${suggestion.city ? suggestion.city + ", " : ""}${suggestion.postCode ? suggestion.postCode + ", " : ""}${suggestion.country ? suggestion.country : ''}`
    setMainVal(suggestion.full_address ? suggestion.full_address : add)
    setParams((prev) => {
      return {
        ...prev,
        position: "",
        name: suggestion.name,
        email: suggestion.email,
        website: suggestion.website || "",
        corporateForm: suggestion.corporateForm,
        branch: suggestion.branch,
        street: suggestion.street,
        postCode: suggestion.postCode,
        city: suggestion.city,
        country: suggestion.country ? suggestion.country : "germany",
        lat: suggestion.lat,
        long: suggestion.long,
        houseNo: suggestion.houseNo,
        full_address: suggestion.full_address ? suggestion.full_address : add
      };
    });
    setOwnerId(suggestion.ownerId);
    setSuggestionName(suggestion.name);
    setParamsLoaded((prev) => {
      return {
        ...prev,
        corporateForm: !!suggestion.corporateForm,
        branch: !!suggestion.branch,
        email: !!suggestion.email,
      };
    });
    await setSuggestionLoaded(true);
  };
  const changeRole = (roles) => {
    setRoleSelected(false);
    // CompanyRoles always emits English name_en values — persist those as-is.
    setParam("branch", (roles || []).join(","));
  };
  const handleBack = () => {
    setVisible(false);
    setTimeout(() => {
      goBack();
    }, 1000);
  };

  const _getDepartmentAndLocations = async (id) => {
    const { data } = await callAPI(`/company/getDeptLocation/${id}`, {}, "GET");
    console.log('--------------------Dep Loc', data)
    if (data.status) {
      setdeptloc([...data.data.getCompanyDept])
    }
  }
  const _onClickOfCompnay = (comp) => {
    setShowSuggestion(false)
    setParam('name', comp.name)
    _getDepartmentAndLocations(comp.id)
    getSuggestion(comp)
  }
  const isDeskTopResolution = useSelector(state => state.isDeskTopResolution)
  return (
    <React.Fragment>
      <style>{`
        .add_company .form-bottom::-webkit-scrollbar {
          display: none;
        }
        .add_company .form-bottom {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
          <div className="w-300 add_company add-company-page">
            {successMessage && (
              <div className="create-message-loading-overlay add-company-page__overlay">
                <div className="create-message-loading-content add-company-page__overlay-content">
                  <span className="material-symbols-outlined add-company-page__success-icon">check_circle</span>
                  <p className="add-company-page__success-text">{successMessage}</p>
                  <button
                    type="button"
                    className="kj-btn kj-btn--primary add-company-page__ok-btn"
                    onClick={() => history.push("/profile")}
                  >
                    OK
                  </button>
                </div>
              </div>
            )}
            {loadingStage && (
              <div className="create-message-loading-overlay add-company-page__overlay">
                <div className="create-message-loading-content add-company-page__overlay-content">
                  <div className="create-message-loading-spinner">
                    <Oval
                      height={50}
                      width={50}
                      color={KJUUP_COLORS.base_color}
                      secondaryColor="rgba(var(--kjuup-accent-rgb), 0.3)"
                      wrapperStyle={{}}
                      visible={true}
                      ariaLabel="loading"
                      strokeWidth={4}
                    />
                  </div>
                  <p className="create-message-loading-subtext add-company-page__wait-text">{strings.please_wait}</p>
                </div>
              </div>
            )}
            <div className="page-header">
              <a className="page-header-back pointer" onClick={handleBack}>
                <span 
                  className="material-symbols-outlined add-company-page__back"
                >
                  keyboard_arrow_left
                </span>
              </a>
              <h2 className="page-header-title">
                {strings.add_or_join_company}
              </h2>
            </div>
            <div
              className="form-bottom add-company-page__form"
              onSubmit={(e) => {
                e.preventDefault();
                requestConfirmation();
              }}
            >
              <Form className="add_company_from" autoComplete="new-password">
                <Form.Group controlId="formBasicEmail">
                  <Form.Control
                    value={params.name}
                    onChange={(e) => {
                      const newName = e.target.value;
                      setSearchSuggestion(newName);
                      
                      // If suggestion was loaded and user is changing the name, clear all pre-filled content
                      if (suggestionLoaded && newName !== suggestionName) {
                        setSuggestionLoaded(false);
                        setSuggestionName(null);
                        setOwnerId(null);
                        setMainVal('');
                        setdeptloc([]);
                        setParams((prev) => ({
                          name: newName,
                          email: "",
                          website: "",
                          corporateForm: "",
                          branch: "",
                          street: "",
                          postCode: "",
                          city: "",
                          country: "",
                          lat: "",
                          long: "",
                          houseNo: "",
                          full_address: "",
                          deptLocation: "",
                          deptLocationName: ""
                        }));
                        setParamsLoaded({
                          name: false,
                          email: false,
                          corporateForm: false,
                          branch: false,
                        });
                      } else {
                        setParam('name', newName);
                      }
                    }}
                    type="text"
                    placeholder={strings.name_of_the_company}
                  />
                  {errors.name && (
                    <small className="pl-2 text-danger">{errors.name}</small>
                  )}
                </Form.Group>
                {
                  showSuggestion &&
                  <div
                    onScroll={(e) => {
                      const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
                      if (bottom) {
                        _onEndOfSuggestions()
                      }
                    }}
                    className="company-suggestions-dropdown">
                    <div className="company-suggestions-list">
                      {companiesSuggestion.map((suggestion, index) => {
                        const companyImage = suggestion.logo || suggestion.avatar;
                        // Format: street, house number - post code city, country
                        const streetPart = [suggestion.street, suggestion.houseNo].filter(Boolean).join(", ");
                        const cityPart = [suggestion.postCode, suggestion.city].filter(Boolean).join(" ");
                        const formattedAddress = [streetPart, cityPart, suggestion.country].filter(Boolean).join(streetPart && cityPart ? " - " : ", ");
                        const displayAddress = suggestion.full_address || formattedAddress;
                        return (
                          <div
                            key={suggestion.id || index}
                            className="company-suggestion-item"
                            onClick={() => {
                              setdeptloc(null)
                              _onClickOfCompnay(suggestion)
                            }}
                          >
                            {companyImage && (
                              <img
                                className="company-suggestion-avatar"
                                src={BASE_URL + companyImage}
                                alt={suggestion.name}
                              />
                            )}
                            <div className="company-suggestion-content">
                              <span className="company-suggestion-name">
                                {suggestion.name}
                              </span>
                              {displayAddress && (
                                <p className="company-suggestion-detail">
                                  {displayAddress}
                                </p>
                              )}
                              {suggestion.branch && (
                                <p className="company-suggestion-detail">
                                  {suggestion.branch.split(",").map((item, idx) => (idx ? ", " : "") + convertBranchRole(item, isGerm))}
                                </p>
                              )}
                              {suggestion.email && (
                                <p className="company-suggestion-detail">
                                  {suggestion.email}
                                </p>
                              )}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                    {isGettingSuggestion &&
                      <div className="company-suggestion-loader">
                        <Rings
                          height="60"
                          width="60"
                          color="var(--kjuup-accent)"
                          radius="6"
                          visible={true}
                          ariaLabel="rings-loading"
                        />
                      </div>
                    }
                  </div>
                }

                <Form.Group controlId="formBasicPassword">
                  <LocationSearchInput
                    custom
                    disbled={suggestionLoaded && user?.id !== ownerId}
                    defaultValue={params.full_address}
                    placeHolder={strings.Address}
                    setVal={(e) => {
                      setMainVal(e)
                      setSearchCity(e)
                      setParam('full_address', e)
                    }}
                    val={mainVal}
                    setFull={(val) => {
                      setMainVal(val)
                      setParam('full_address', val)
                    }}
                    onAddressSelect={applyAddressSuggestion}
                  />
                  {errors.full_address && (
                    <small className="pl-2 text-danger">
                      {errors.full_address}
                    </small>
                  )}
                </Form.Group>

                <Form.Group className="select_coustom position-relative role-search-form-group">
                  {(!paramsLoaded.branch || user?.id === ownerId) ? (
                    <CompanyRoles
                      searchMode={true}
                      selectedRoles={params.branch}
                      hideRoles={() => {}}
                      setRoles={setRoleSelected}
                      selectPosition={changeRole}
                      position={companyRoles}
                    />
                  ) : (
                    <div className="register_role add-company-page__branch-readonly">
                      {params.branch && <span>{params.branch?.split(",")?.map((itm, index) => (index ? ", " : "") + convertBranchRole(itm, isGerm))}</span>}
                    </div>
                  )}
                  {errors.branch && (
                    <small className="pl-2 text-danger">{errors.branch}</small>
                  )}
                </Form.Group>
                {deptloc && deptloc?.length > 0 ?
                  <Form.Group className="select_coustom border-0 hello position-relative">
                    <a
                      ref={deptLocButtonRef}
                      className="register_role pointer text-truncate position-relative"
                      onClick={(e) => {
                        e.preventDefault();
                        setShowDepartModal(true);
                      }}
                    >
                      {!params.deptLocationName && (
                        <span>
                          {strings.dep_loc}{" "}
                        </span>
                      )}
                      {params.deptLocationName && <span>{params.deptLocationName}</span>}
                      <BsChevronDown />
                    </a>
                    {errors.deptLocation && (
                      <small className="pl-2 text-danger">
                        {errors.deptLocation}
                      </small>
                    )}
                  </Form.Group>
                  :
                  <></>
                }
                <Form.Group controlId="formBasicPassword">
                  <Form.Control
                    disabled={paramsLoaded.email && user?.id !== ownerId}
                    value={params.email}
                    onChange={(e) => setParam("email", e.target.value)}
                    type="text"
                    placeholder={strings.company_e_mail}
                  />
                  {errors.email && (
                    <small className="pl-2 text-danger">{errors.email}</small>
                  )}
                </Form.Group>
                <Form.Group controlId="formCompanyWebsite">
                  <Form.Control
                    value={params.website || ""}
                    onChange={(e) => setParam("website", e.target.value)}
                    type="text"
                    placeholder={strings.website_optional || `${strings.website} (${strings.optional || 'optional'})`}
                    autoComplete="off"
                  />
                </Form.Group>
                <button className="kj-btn kj-btn--outline" type="submit">
                  {strings.add_join}
                </button>
              </Form>
            </div>
          </div>
          {showCorporateForm && (
            <CompanyCorporateDialog
              handleClose={(e) => setCorporateForm(false)}
              setParam={setParam}
              corporateForm={corporateForm}
            />
          )}
          {showPositionDialog && (
            <CompanyPositionDialog
              handleClose={(e) => setPositionDialog(false)}
              setParam={setParam}
              setSelectName={setSelectName}
              positions={Positions}
            />
          )}
          {showDepartModal && (
            <DepartLocaDialogue
              handleClose={(e) => setShowDepartModal(false)}
              setParam={setParam}
              setSelectName={setSelectName}
              positions={deptloc}
              setDepName={(name) => {
                setParam('deptLocationName', name)
              }}
              anchorElement={deptLocButtonRef.current}
              showDepartModal={showDepartModal}
            />
          )}
        
    </React.Fragment>
  );
}

export default AddCompany;
